// @ts-strict-ignore
import { ErrorHandler, Injectable, inject } from '@angular/core';
import { SnackBarService } from '@app/_shared/snack-bars/snack-bar.service';
import { environment } from '@env/environment';
import { TranslocoService } from '@jsverse/transloco';
import * as Sentry from '@sentry/angular';

export const STALE_CHUNK_ERROR__RELOAD_REQUESTED = 'stale-chunk-error--reload-requested';

@Injectable({
  providedIn: 'root',
})
export class CustomErrorHandler implements ErrorHandler {
  private translocoService = inject(TranslocoService);
  private snackbarService = inject(SnackBarService);
  private hasActiveSnackBar = false;

  handleError(error: any) {
    if (sessionStorage.getItem(STALE_CHUNK_ERROR__RELOAD_REQUESTED)) {
      return;
    }

    const exception = error.originalError ?? error.error ?? error;

    if (this.isStaleChunkError(exception?.message ?? '')) {
      sessionStorage.setItem(STALE_CHUNK_ERROR__RELOAD_REQUESTED, 'true');
      window.location.reload();
      return;
    }

    if (!environment.production) {
      console.error(error);
    }

    Sentry.captureException(
      exception instanceof Error
        ? exception
        : new Error(exception?.message ?? `Non-Error exception: ${exception?.constructor?.name ?? String(exception)}`),
      {
        extra: { originalError: error },
      },
    );

    const isIncompatibleError = !error.error || !Array.isArray(error.error.errors);

    if (!this.hasActiveSnackBar && isIncompatibleError) {
      this.hasActiveSnackBar = true;

      const toast = this.snackbarService.openFailure({
        header: this.translocoService.translate('general.messages.globalError.header'),
        body: this.translocoService.translate('general.messages.globalError.body'),
      });

      toast.subscribe(() => {
        this.hasActiveSnackBar = false;
      });
    }
  }

  private isStaleChunkError(message: string): boolean {
    // Chrome/Firefox: "... dynamically imported module ..."
    // Safari: "... Importing a module script failed ..."
    return message.includes('dynamically imported module') || message.includes('Importing a module script failed');
  }
}
